<template>
  <div class="ClickContinue">
      <el-dialog width="313px" :close-on-click-modal="false" :show-close="false" :visible.sync="clickContinueStatus" :before-close="closeClickContinue" style="margin-top: 20vh;">
        <img @click="closeClickContinue" src="~common/images/examination/icon-jixu.png" alt="点击继续">
      </el-dialog>
      <!-- end 点击继续 -->
  </div>
</template>

<script>
export default {
  name: 'ClickContinue',
  data () {
    return {
        clickContinueStatus: false
    }
  },
  mounted () {},
  methods: {
      startClickContinue() { // 开启弹窗
        this.clickContinueStatus = true
      },
      closeClickContinue() { // 关闭弹窗
        this.clickContinueStatus = false
        if (this.$parent.examinationTimeCalculation) {
          // 弹窗关闭后触发开启 设置区域内的考试时间
          this.$parent.examinationTimeCalculation()
        }
      }
  },
  filters: {},
  watch: {},
  computed: {},
  components: {}
}
</script>

<style lang="scss" type="text/scss" scope>
.ClickContinue {
    img {
        display: block;
        cursor: pointer;
        margin: auto;
        margin-bottom: 30px;
        width: 95px;
        height: 105px;
    }
}
</style>